import { hotjar } from 'react-hotjar'
import { getAreCookiesAccepted } from 'services/cookies'

export const HAS_HOTJAR =
  process.env.REACT_APP_HOTJAR || window.REACT_APP_HOTJAR

export const initHotjar = () => {
  const areCookiesAccepted = getAreCookiesAccepted()
  if (areCookiesAccepted && HAS_HOTJAR && HAS_HOTJAR.length > 0) {
    hotjar.initialize(2326017, 6)
  }
}
